import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="p-8 font-sans bg-gray-50 min-h-screen">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-800">Terms of Use</h1>
      </div>
      <div className="max-w-4xl mx-auto bg-white p-8 shadow-lg rounded-lg">
        <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
        <p className="leading-relaxed mb-4">
          Welcome to our e-commerce website. These Terms of Use ("Terms") govern your use of our website and services. By accessing or using our website, you agree to comply with and be bound by these Terms.
        </p>
        <h2 className="text-2xl font-semibold mb-4">Account Responsibilities</h2>
        <p className="leading-relaxed mb-4">
          When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your account. You agree to accept responsibility for all activities that occur under your account.
        </p>
        <h2 className="text-2xl font-semibold mb-4">Prohibited Activities</h2>
        <p className="leading-relaxed mb-4">
          You agree not to engage in any of the following prohibited activities:
        </p>
        <ul className="list-disc pl-5 mb-4">
          <li>Violating any laws or regulations.</li>
          <li>Infringing on any intellectual property rights.</li>
          <li>Posting any false, misleading, or defamatory content.</li>
          <li>Distributing viruses or any other harmful computer code.</li>
          <li>Engaging in any fraudulent activities.</li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4">Intellectual Property</h2>
        <p className="leading-relaxed mb-4">
          All content on our website, including text, graphics, logos, and images, is the property of our company or its content suppliers and is protected by copyright laws. You may not reproduce, distribute, or create derivative works from any content on our website without our prior written permission.
        </p>
        <h2 className="text-2xl font-semibold mb-4">Termination</h2>
        <p className="leading-relaxed mb-4">
          We reserve the right to terminate or suspend your account and access to our website at our discretion, without notice, for conduct that we believe violates these Terms or is harmful to our users or business interests.
        </p>
        <h2 className="text-2xl font-semibold mb-4">Changes to Terms</h2>
        <p className="leading-relaxed mb-4">
          We may update these Terms from time to time. We will notify you of any changes by posting the new Terms on this page. You are advised to review these Terms periodically for any changes. Changes to these Terms are effective when they are posted on this page.
        </p>
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
        <p className="leading-relaxed">
          If you have any questions about these Terms, please contact us at:
        </p>
        <p className="leading-relaxed">
          <strong>Email:</strong> syedmughis4541@gmail.com<br />
          <strong>Phone:</strong> +92 319 3039832<br />
          <strong>Address:</strong> Main Shahah-e-Faisal near PC Hotel
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
